import * as React from "react";
import { withStyles, WithStyles, Theme, createStyles } from "./mui/styles";
import Typography from "./mui/Typography";
import Select from "./mui/Select";
import Input from '@material-ui/core/Input';
import MenuItem from './mui/MenuItem';
import Grid from "./mui/Grid";
import PaginationActions, { PaginationActionsProps } from "./PaginationActions";

export interface PaginationProps extends PaginationActionsProps {
    rowsPerPageOptions?: number[];
    labelRowsPerPage?: string;
    allowItemsCountInfo?: boolean;
    onChangeRowsPerPage: (newRowsPerPage: number) => void;
}

declare type Props = PaginationProps & WithStyles<typeof styles>;

/*
interface Props extends PaginationActionsProps {
    rowsPerPageOptions: number[];
    labelRowsPerPage?: string;
    onChangeRowsPerPage: (newRowsPerPage: number) => void;
}

export declare type PaginationProps = Props & WithStyles<typeof styles>;
*/
class Pagination extends React.PureComponent<Props>{
    render() {

        const {
            classes,
            count,
            labelRowsPerPage,
            onChangePage,
            onChangeRowsPerPage,
            page,
            rowsPerPage,
            rowsPerPageOptions,
            pageCount,
            allowItemsCountInfo,
            ...other
        } = this.props;

        //return <Toolbar className={classes.toolbar}>
        return <Grid container spacing={8} justify="space-between" alignItems="center" className={classes.root}>
            <Grid item>
                <PaginationActions count={count} onChangePage={onChangePage} page={page} rowsPerPage={rowsPerPage} pageCount={pageCount} />
            </Grid>
            {rowsPerPageOptions && rowsPerPageOptions.length > 1 && <Grid item>
                <Grid container alignItems="center">
                    <Grid>
                        <Typography variant="caption" className={classes.caption} align="center">
                            {labelRowsPerPage ? labelRowsPerPage : 'Řádků na stránku:'}
                        </Typography>
                    </Grid>
                    <Grid>
                        <Select
                            classes={{
                                root: classes.selectRoot,
                                select: classes.select,
                                icon: classes.selectIcon,
                            }}
                            input={<Input className={classes.input} disableUnderline />}
                            value={rowsPerPage}
                            onChange={(e: any) => onChangeRowsPerPage(e.target.value)}
                        >
                            {rowsPerPageOptions.map(rowsPerPageOption => (
                                <MenuItem key={rowsPerPageOption} value={rowsPerPageOption}>
                                    {rowsPerPageOption}
                                </MenuItem>
                            ))}
                        </Select>

                    </Grid>
                </Grid>
            </Grid>}

            {allowItemsCountInfo && <Grid item>
                <Typography variant="caption" className={classes.caption} align="center" >
                    {labelRowsPerPage ? labelRowsPerPage : 'Počet položek: '}
                    {count}
                </Typography>
            </Grid>}
        </Grid>

        //  </Toolbar >
    }
}



const styles = (theme: Theme) => {

    return createStyles({
        root: {
            height: 'auto',
            minHeight: 0,
            padding: 4,
        },
        caption: {
            flexShrink: 0,
        },
        input: {
            fontSize: 'inherit',
            flexShrink: 0,
        },
        selectRoot: {
            marginRight: theme.spacing.unit * 4,
            marginLeft: theme.spacing.unit,
            color: theme.palette.text.secondary,
        },
        select: {
            paddingLeft: theme.spacing.unit,
            paddingRight: theme.spacing.unit * 2,
            minWidth: 40
        },
        selectIcon: {
            top: 1,
            marginLeft: 5
        },
    })
}

export default withStyles(styles)(Pagination);